// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/supply_48_data_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { BilateralTradeProductType } from "../../bfftypes/v1/bilateral_trade_product_type_pb";
import { file_bfftypes_v1_bilateral_trade_product_type } from "../../bfftypes/v1/bilateral_trade_product_type_pb";
import type { TradingExecutionRoute } from "../../bfftypes/v1/trading_execution_route_pb";
import { file_bfftypes_v1_trading_execution_route } from "../../bfftypes/v1/trading_execution_route_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Decimal } from "../../google/type/decimal_pb";
import { file_google_type_decimal } from "../../google/type/decimal_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/supply_48_data_model.proto.
 */
export const file_bffuser_v1_supply_48_data_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_bfftypes_v1_bilateral_trade_product_type, file_bfftypes_v1_trading_execution_route, file_buf_validate_validate, file_google_protobuf_timestamp, file_google_type_date, file_google_type_decimal]);

/**
 * Supply48MarketSourceDetail は市場 source 固有の表示属性。
 * Mirrors internalapi.v1.Supply48MarketSourceDetail。
 *
 * @generated from message bffuser.v1.Supply48MarketSourceDetail
 */
export type Supply48MarketSourceDetail = Message<"bffuser.v1.Supply48MarketSourceDetail"> & {
  /**
   * @generated from field: bffuser.v1.Supply48MarketKind market_kind = 1;
   */
  marketKind: Supply48MarketKind;
};

/**
 * Describes the message bffuser.v1.Supply48MarketSourceDetail.
 * Use `create(Supply48MarketSourceDetailSchema)` to create a new message.
 */
export const Supply48MarketSourceDetailSchema: GenMessage<Supply48MarketSourceDetail> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_48_data_model, 0);

/**
 * Supply48ContractSourceDetail は取引 source 固有の表示属性。
 * Mirrors internalapi.v1.Supply48ContractSourceDetail。
 *
 * @generated from message bffuser.v1.Supply48ContractSourceDetail
 */
export type Supply48ContractSourceDetail = Message<"bffuser.v1.Supply48ContractSourceDetail"> & {
  /**
   * 相対先名称 (列ヘッダ表示用)。
   *
   * @generated from field: string trading_partner_name = 1;
   */
  tradingPartnerName: string;

  /**
   * 取引 ID (取引識別コード)。行見出しに取引先名の下段として表示する (AC-S4D-039)。
   * 相対取引契約管理の一覧に表示される取引 ID・CSV 突合キーと同一で、両画面を照合できる (#6697)。
   *
   * @generated from field: string public_trade_id = 2;
   */
  publicTradeId: string;

  /**
   * 契約電力量 (MW)。契約値超過 (AC-018) の警告判定に使う。
   * NULL の場合は警告なし。
   *
   * @generated from field: optional google.type.Decimal contract_volume_mw = 3;
   */
  contractVolumeMw?: Decimal;

  /**
   * 成約 ID (社内採番 SC-YYYYMMDD-NNN)。複数の取引を束ねる成約単位の識別子で、
   * CSV 突合キーの public_trade_id (取引識別コード) とは別物。照合キーではないため
   * 行見出しには表示しない (#6697、AC-S4D-039)。
   *
   * @generated from field: string deal_id = 4;
   */
  dealId: string;

  /**
   * 約定経路。48 点データ画面では相対取引カテゴリ内で「相対取引 / 常時BU」を判別・表示するために使う
   * (AC-S4D-001。常時BU は独立カテゴリに分離せず、取引種別としてこの経路から導出する)。
   *
   * @generated from field: bfftypes.v1.TradingExecutionRoute execution_route = 5;
   */
  executionRoute: TradingExecutionRoute;

  /**
   * 商品形態 (定型 / 非定型 / スプレッド)。相対取引と同じ導出規則
   * (スプレッドを先に判定し、時間帯区分・カスタム帯域・数量から定型 / 非定型を決める)。
   * 表示用の商品形態で、48点データの派生とは判定が異なる (派生はスプレッドを見ず、
   * 帯域・数量の形で非定型を判定する)。帯域・数量の無いスプレッドの脚は、行は全コマ 0 の
   * ベースラインだがこの値はスプレッドになるため、ベースラインかどうかの判定には使えない。
   *
   * @generated from field: bfftypes.v1.BilateralTradeProductType product_type = 6;
   */
  productType: BilateralTradeProductType;
};

/**
 * Describes the message bffuser.v1.Supply48ContractSourceDetail.
 * Use `create(Supply48ContractSourceDetailSchema)` to create a new message.
 */
export const Supply48ContractSourceDetailSchema: GenMessage<Supply48ContractSourceDetail> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_48_data_model, 1);

/**
 * Supply48DataSource は供給源単位の 48 点データ (source × 複数日) を表す
 * (旧 Supply48DataLeg を改組)。
 *
 * @generated from message bffuser.v1.Supply48DataSource
 */
export type Supply48DataSource = Message<"bffuser.v1.Supply48DataSource"> & {
  /**
   * 供給源 UUID (行 identity)。
   *
   * @generated from field: string supply_48_source_id = 7;
   */
  supply48SourceId: string;

  /**
   * 供給源種別。
   *
   * @generated from field: bffuser.v1.Supply48SourceType source_type = 8;
   */
  sourceType: Supply48SourceType;

  /**
   * エリアコード。売り契約 = sell_area_code / 買い契約 = buy_area_code。
   * 市場 source は market_channel.area_code (channel から読み出し時に導出)。
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 4;
   */
  areaCode: AreaCode;

  /**
   * 種別固有の表示属性。取引・市場のみ (発電 variant は投入フロー実装時に追加)。
   *
   * @generated from oneof bffuser.v1.Supply48DataSource.detail
   */
  detail: {
    /**
     * @generated from field: bffuser.v1.Supply48ContractSourceDetail contract = 9;
     */
    value: Supply48ContractSourceDetail;
    case: "contract";
  } | {
    /**
     * @generated from field: bffuser.v1.Supply48MarketSourceDetail market = 10;
     */
    value: Supply48MarketSourceDetail;
    case: "market";
  } | { case: undefined; value?: undefined };

  /**
   * 48 点行がある日のみ含む。無い日は不在 (= 空セル)。
   *
   * @generated from field: repeated bffuser.v1.Supply48DataDay days = 6;
   */
  days: Supply48DataDay[];
};

/**
 * Describes the message bffuser.v1.Supply48DataSource.
 * Use `create(Supply48DataSourceSchema)` to create a new message.
 */
export const Supply48DataSourceSchema: GenMessage<Supply48DataSource> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_48_data_model, 2);

/**
 * Supply48DataDay は 1 日分の 48 コマ値を表す。
 *
 * @generated from message bffuser.v1.Supply48DataDay
 */
export type Supply48DataDay = Message<"bffuser.v1.Supply48DataDay"> & {
  /**
   * 受渡日。
   *
   * @generated from field: google.type.Date delivery_date = 1;
   */
  deliveryDate?: Date;

  /**
   * 48 コマの値。index+1 = コマ番号 (1〜48)。
   * 空セル = value 未設定の Supply48SlotValue。
   *
   * @generated from field: repeated bffuser.v1.Supply48SlotValue slots = 3;
   */
  slots: Supply48SlotValue[];

  /**
   * 自動計算値の 48 コマ。0 個 (自動値なし) または 48 個。
   * min は付けない (0 個も有効)。usecase で 0 or 48 を検証する。
   *
   * @generated from field: repeated bffuser.v1.Supply48SlotValue auto_slots = 4;
   */
  autoSlots: Supply48SlotValue[];

  /**
   * 手動編集されたコマ番号の一覧 (1〜48)。
   *
   * @generated from field: repeated int32 manual_edit_komas = 5;
   */
  manualEditKomas: number[];

  /**
   * 楽観ロック用タイムスタンプ (µs 精度)。
   * SaveSupply48DataRow.expected_updated_at に round-trip すること
   * (proto Timestamp のまま保持)。
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;

  /**
   * この日が契約の受渡期間の外であるか。期間短縮後も据え置かれた確定値の行
   * (AC-S4D-054 / AC-S4D-055) を、その契約の列に読み取り専用で表示するための印
   * (supply-48-data.md 対象日選択)。true の日は全コマ編集不可とし、保存も拒否される。
   * 取引由来の列でのみ意味を持ち、市場の行では常に false。
   * 48 点行がある日にしか値が立たず、行の無い期間外の日は判別できない。
   *
   * @generated from field: bool outside_delivery_period = 7;
   */
  outsideDeliveryPeriod: boolean;
};

/**
 * Describes the message bffuser.v1.Supply48DataDay.
 * Use `create(Supply48DataDaySchema)` to create a new message.
 */
export const Supply48DataDaySchema: GenMessage<Supply48DataDay> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_48_data_model, 3);

/**
 * Supply48SlotValue は 1 コマの値を表す。value が unset の場合は空セル扱い。
 * Mirrors internalapi.v1.Supply48SlotValue。
 *
 * @generated from message bffuser.v1.Supply48SlotValue
 */
export type Supply48SlotValue = Message<"bffuser.v1.Supply48SlotValue"> & {
  /**
   * @generated from field: optional int32 value = 1;
   */
  value?: number;
};

/**
 * Describes the message bffuser.v1.Supply48SlotValue.
 * Use `create(Supply48SlotValueSchema)` to create a new message.
 */
export const Supply48SlotValueSchema: GenMessage<Supply48SlotValue> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_48_data_model, 4);

/**
 * GateCloseInfo はゲートクローズ境界情報を表す。
 * フロントエンドがセルロック判定に使う。
 * 「行日付 < today → 全ロック / = today → コマ ≤ gc_passed_koma ロック /
 * = today + 1 → コマ ≤ tomorrow_gc_passed_koma ロック / それより後 → ロックなし」。
 * Mirrors internalapi.v1.GateCloseInfo。
 * 新規の利用は GateCloseFrontier (gate_close_model.proto) に置き換えた (ListSupply48DataResponse.gate_close は deprecated)。
 *
 * @generated from message bffuser.v1.GateCloseInfo
 */
export type GateCloseInfo = Message<"bffuser.v1.GateCloseInfo"> & {
  /**
   * JST 今日 (backend 計算)。
   *
   * @generated from field: google.type.Date today = 1;
   */
  today?: Date;

  /**
   * 当日の GC 済み最終コマ番号 (0 = なし)。
   *
   * @generated from field: int32 gc_passed_koma = 2;
   */
  gcPassedKoma: number;

  /**
   * 翌日 (today + 1) の GC 済み最終コマ番号 (0 = なし)。翌日のコマ 1 / 2 は
   * 前日 23:00 / 23:30 JST に GC 済みになるため、23 時台だけ 1 または 2 になる。
   *
   * @generated from field: int32 tomorrow_gc_passed_koma = 3;
   */
  tomorrowGcPassedKoma: number;
};

/**
 * Describes the message bffuser.v1.GateCloseInfo.
 * Use `create(GateCloseInfoSchema)` to create a new message.
 */
export const GateCloseInfoSchema: GenMessage<GateCloseInfo> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_48_data_model, 5);

/**
 * SaveSupply48DataRow は保存する 1 行分のデータを表す。
 *
 * @generated from message bffuser.v1.SaveSupply48DataRow
 */
export type SaveSupply48DataRow = Message<"bffuser.v1.SaveSupply48DataRow"> & {
  /**
   * 供給源 UUID (行 identity)。常時必須 (ignore 不要)。
   *
   * @generated from field: string supply_48_source_id = 7;
   */
  supply48SourceId: string;

  /**
   * 受渡日。
   *
   * @generated from field: google.type.Date delivery_date = 2;
   */
  deliveryDate?: Date;

  /**
   * 48 全コマの値 (server が差分計算する)。
   *
   * @generated from field: repeated bffuser.v1.Supply48SlotValue slots = 4;
   */
  slots: Supply48SlotValue[];

  /**
   * 行の全量を洗い替え申告するコマ番号一覧。
   *
   * @generated from field: repeated int32 manual_edit_komas = 5;
   */
  manualEditKomas: number[];

  /**
   * 楽観ロック用タイムスタンプ。無し = 新規 INSERT。
   *
   * @generated from field: optional google.protobuf.Timestamp expected_updated_at = 6;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.SaveSupply48DataRow.
 * Use `create(SaveSupply48DataRowSchema)` to create a new message.
 */
export const SaveSupply48DataRowSchema: GenMessage<SaveSupply48DataRow> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_48_data_model, 6);

/**
 * SavedSupply48DataRow は保存後の 1 行分のレスポンスを表す。
 * 再 fetch なしで連続編集できるよう新 updated_at のみを返す。
 * Mirrors internalapi.v1.SavedSupply48DataRow。
 *
 * @generated from message bffuser.v1.SavedSupply48DataRow
 */
export type SavedSupply48DataRow = Message<"bffuser.v1.SavedSupply48DataRow"> & {
  /**
   * 供給源 UUID (行 identity)。
   *
   * @generated from field: string supply_48_source_id = 7;
   */
  supply48SourceId: string;

  /**
   * 受渡日。
   *
   * @generated from field: google.type.Date delivery_date = 2;
   */
  deliveryDate?: Date;

  /**
   * 新しい楽観ロック token。
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 4;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.SavedSupply48DataRow.
 * Use `create(SavedSupply48DataRowSchema)` to create a new message.
 */
export const SavedSupply48DataRowSchema: GenMessage<SavedSupply48DataRow> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_48_data_model, 7);

/**
 * ImportSupply48DataRow は CSV 取込 1 行分のデータを表す。
 * Mirrors internalapi.v1.ImportSupply48DataRow。
 *
 * @generated from message bffuser.v1.ImportSupply48DataRow
 */
export type ImportSupply48DataRow = Message<"bffuser.v1.ImportSupply48DataRow"> & {
  /**
   * CSV 上の行番号 (1 始まり、ヘッダー行を除く)。エラー・結果の対応付けに使う。
   *
   * @generated from field: int32 row_number = 1;
   */
  rowNumber: number;

  /**
   * 取引識別コード (PublicTradeId)。
   *
   * @generated from field: string public_trade_id = 2;
   */
  publicTradeId: string;

  /**
   * @generated from field: google.type.Date delivery_date = 3;
   */
  deliveryDate?: Date;

  /**
   * index+1 = コマ番号。value unset = 「変更しない」。値は kWh 非負整数。
   * frontend parse は列数チェック (51 列) で不一致行を行エラーにし、送信 payload は
   * 常に 48 要素に正規化する契約。min_items=48 は bypass payload への防御で、
   * 違反は InvalidArgument (契約エラー) — 業務行エラー (2xx + status=ERROR) とは別経路。
   *
   * @generated from field: repeated bffuser.v1.Supply48SlotValue slots = 4;
   */
  slots: Supply48SlotValue[];

  /**
   * true = 当該 (取引ID, 受渡日) の 48 コマを全て論理削除する (spec 51 列目
   * `delete`、AC-SUPPLY-026)。true の行はコマ列 (slots) を無視する。
   *
   * @generated from field: bool delete = 5;
   */
  delete: boolean;
};

/**
 * Describes the message bffuser.v1.ImportSupply48DataRow.
 * Use `create(ImportSupply48DataRowSchema)` to create a new message.
 */
export const ImportSupply48DataRowSchema: GenMessage<ImportSupply48DataRow> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_48_data_model, 8);

/**
 * Supply48SourceType は 48 点データの供給源種別を表す (取引 / 発電(予約) / 市場(予約))。
 * 当面 CONTRACT のみが応答に現れる。Mirrors internalapi.v1.Supply48SourceType。
 *
 * @generated from enum bffuser.v1.Supply48SourceType
 */
export enum Supply48SourceType {
  /**
   * @generated from enum value: SUPPLY48_SOURCE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SUPPLY48_SOURCE_TYPE_CONTRACT = 1;
   */
  CONTRACT = 1,

  /**
   * @generated from enum value: SUPPLY48_SOURCE_TYPE_GENERATION = 2;
   */
  GENERATION = 2,

  /**
   * @generated from enum value: SUPPLY48_SOURCE_TYPE_MARKET = 3;
   */
  MARKET = 3,
}

/**
 * Describes the enum bffuser.v1.Supply48SourceType.
 */
export const Supply48SourceTypeSchema: GenEnum<Supply48SourceType> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_supply_48_data_model, 0);

/**
 * Supply48MarketKind は 48 点データの市場 source の JEPX 市場種別を表す。
 * Mirrors internalapi.v1.Supply48MarketKind。
 *
 * @generated from enum bffuser.v1.Supply48MarketKind
 */
export enum Supply48MarketKind {
  /**
   * @generated from enum value: SUPPLY48_MARKET_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * スポット (ブロック約定含む)
   *
   * @generated from enum value: SUPPLY48_MARKET_KIND_SPOT = 1;
   */
  SPOT = 1,

  /**
   * 時間前
   *
   * @generated from enum value: SUPPLY48_MARKET_KIND_INTRADAY = 2;
   */
  INTRADAY = 2,
}

/**
 * Describes the enum bffuser.v1.Supply48MarketKind.
 */
export const Supply48MarketKindSchema: GenEnum<Supply48MarketKind> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_supply_48_data_model, 1);

